import { capitalize } from "es-toolkit/string";
import type { RunStatus } from "src/queries/pipelines/pipelineRuns.types";
import { formatLargeNumber } from "src/utils/number";
import RunStatusBar from "../RunsStatusBars/components/RunStatusBar/RunStatusBar";
import { RUN_STATUSES } from "../RunsStatusBars/RunsStatusBars.constants";

const StatusesCount = ({ data }: { data: Partial<Record<RunStatus, number>> }) => (
  <div className="grid grid-cols-[auto_1fr_auto] gap-1 text-base">
    {(Object.entries(data) as [RunStatus, number][]).map(([status, count]) => (
      <div key={status} className="contents">
        <div className="grid grid-cols-subgrid col-span-3 items-center gap-x-3">
          <RunStatusBar status={status} />
          <div className="text-right whitespace-nowrap">
            {formatLargeNumber(count, { notation: "standard" })}
          </div>
          <div className="whitespace-nowrap">{capitalize(RUN_STATUSES[status])}</div>
        </div>
      </div>
    ))}
  </div>
);

export default StatusesCount;
